module.exports = __webpack_public_path__ + "static/media/robot-dev.be7db150.png";